import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { HashRouter as Router, Route } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'antd';
import {
  Header,
  Background,
  Works,
  Mouse,
  Footer,
  Messenger,
  PlayGround,
  Intro,
  GA,
  Aboutme,
} from '../Components';

const getHour = () => new Date().getHours();
const currentDayTime = h => (h < 6 || h >= 18 ? 'night' : 'day');

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dayTime: currentDayTime(getHour()),
    };
  }
  onClick = () => {
    this.setState({
      dayTime: this.state.dayTime === 'night' ? 'day' : 'night',
    });
  };

  render() {
    const { className } = this.props;
    const { dayTime } = this.state;
    return (
      <Router>
        <div className={className}>
          <Route component={GA} />
          <Background dayTime={dayTime} />
          <Route
            render={() => <Mouse render={() => (dayTime === 'day' ? <PBall /> : <YBall />)} />}
          />
          <div className="page-container">
            <Header dayTime={dayTime} />
            <div className="content-container">
              <Route exact path="/" render={() => <Intro dayTime={dayTime} />} />
              <Route exact path="/collection" render={() => <Works dayTime={dayTime} />} />
              <Route exact path="/play" render={() => <PlayGround />} />
              <Route exact path="/contact" render={() => <Messenger dayTime={dayTime} />} />
              <Route exact path="/aboutme" render={() => <Aboutme />} />
            </div>
            <div>
              <div style={{ position: 'absolute', zIndex: 1 }}>
                <Test onClick={this.onClick} type="primary" size="large">
                  {dayTime === 'day' ? 'NIGHT' : 'DAY'}
                </Test>
              </div>
              <Footer className="footer" />
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

const Test = styled(Button)`
  height: 30px;
  @media (max-width: 767px) {
    height: 25px;
  }
`;

const YBall = styled.div`
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: yellow;
  border-radius: 5px;
`;
const PBall = styled.div`
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: pink;
  border-radius: 5px;
`;

export default styled(App)`
  width: 100%;
  height: 100%;
  font-size: 20px;
  .page-container {
    width: 100%;
    height: 100%;
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
  }
  .content-container {
    flex-grow: 1;
    width: 100%;
    height: 10px;
  }
  .center {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;



// WEBPACK FOOTER //
// ./src/App/index.js